import { RegexValidator } from './RegexValidator'

export const PHONE_REGEX = /^\d{10}$/

export class PhoneValidator extends RegexValidator {
    constructor() {
        super(PHONE_REGEX, 'validations.phone')
    }

    isValidString = (value: string) => {
        let fixed = (value || '').replace(/\s|\(|\)|-/g, '')
        return !fixed || this.regexp.test(fixed)
    }
}

export const PHONE_VALIDATOR = new PhoneValidator()

export const phoneFormat = (value: string): string => {
    let fixed = (value || '').replace(/\s|\(|\)|-/g, '')
    if (
        fixed.startsWith('55') ||
        fixed.startsWith('33') ||
        fixed.startsWith('55')
    ) {
        return '(##) ####-####'
    }
    return '(###) ###-####'
}
